import { SxProps, Theme } from "@mui/material";

export const userLocationsStyles = {
  groupChipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  } as SxProps<Theme>,

  capacityTooltipSpan: {
    cursor: "help",
    display: "block",
    minWidth: "120px",
    textAlign: "left",
  } as React.CSSProperties,

  capacitySpan: {
    display: "block",
    minWidth: "120px",
    textAlign: "left",
  } as React.CSSProperties,
};
